import { MultiSelect } from 'components'
import React from 'react'

const REGIONS = ['CENTRAL', 'MIDLANDS', 'NORTH', 'SCOTLAND', 'SOUTH', 'SOUTH EAST', 'SOUTH WEST']

type RegionProps = {
  regionState: { sku?: string[]; region: string[] }
  onChange(region: string[], isDefaultAll?: boolean): void
}

export const SelectRegion = (props: RegionProps) => {
  const { regionState, onChange } = props
  const { sku, region } = regionState

  const [regionValues, setRegionValues] = React.useState<string[]>([])

  const isEnabled = !!sku?.length

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (!region.length) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleRegionChange = (selectedRegions: string[], selectedRegionsText: string[], isDefaultAll?: boolean) => {
    onChange(selectedRegions, isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64">
      <MultiSelect
        placeholder="Select region"
        label="Region *"
        id="region"
        disabled={!isEnabled}
        value={region}
        onChange={handleRegionChange}
        onOpen={() => setRegionValues(REGIONS)}
        options={regionValues.map((item) => ({
          text: item,
          value: item,
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
